import React, { useState, useRef, useEffect } from 'react';
import { Button, Icon, Grid, Card, Modal, Label } from 'semantic-ui-react';
import 'react-html5-camera-photo/build/css/index.css';
import debounce from 'lodash.debounce';
import { isMobile } from "utils/isMobile";

const ScanContainer = ({
	submit,
	close,
	cardContent,
	cardBackgroundColor,
	regex
}) => {
	const [barcodeErrorOpen, setBarcodeErrorOpen] = useState(false);
	const [scanInputValue, setScanInputValue] = useState('');
	const barCodeReaderRef = useRef(null);
	const inputRef = useRef();

	useEffect(() => {
		inputRef.current.focus();
		barCodeReaderRef.current.scrollIntoView({
			behavior: 'smooth',
			block: 'end',
		});
	}, []);

	const getScanAlternativeScanner = (value) => {
		if (regex.test(value)) {
			submit(value);
			close();
		} else {
			setBarcodeErrorOpen(true);
			setScanInputValue('');
		}
	};

	const submitAlternativeScanner = debounce(getScanAlternativeScanner, 700);

	const handleKeyDown = (event) => {
		if (event.key === 'Enter' && scanInputValue !== '')
			submitAlternativeScanner(scanInputValue);
	};

	return (
		<div ref={barCodeReaderRef}>
			{isMobile ? <>
				<Card
					style={{
					...styles.card,
					backgroundColor: cardBackgroundColor ?? 'white',
					}}
				>
					<Card.Header style={{ margin: 5 }}>Scan à réaliser</Card.Header>
					<Card.Content>{cardContent}</Card.Content>
				</Card>
				<Card style={styles.card}>
						<Card.Content>
								<div style={styles.borderedCard}>
									<Grid columns={1}>
										<Grid.Row>
											<Grid.Column style={styles.centered}>
												Scanner votre code...
											</Grid.Column>
										</Grid.Row>
										<Grid.Row>
											<Grid.Column
												style={{ ...styles.subtitle, ...styles.centered }}
											>
												<Label>Puis faites "Entrée" ou cliquer sur le bouton valider</Label>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row>
											<Grid.Column style={styles.centered}>
												<input
													style={styles.scanInput}
													ref={inputRef}
													autoFocus
													autoComplete='off'
													type='text'
													name='scanned-value'
													onChange={(e) => {
														setScanInputValue(e.target.value);
													}}
													value={scanInputValue}
													onKeyDown={handleKeyDown}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</div>
						</Card.Content>
						<Card.Content extra>
							<div className='ui two buttons'>	
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										close(true);
									}}
								>
									<Icon name='remove' /> Annuler
								</Button>
								<Button
									primary
									onClick={() => submitAlternativeScanner(scanInputValue)}
									disabled={!regex.test(scanInputValue)}
								>
									<Icon name='checkmark' /> Valider
								</Button>
							</div>
						</Card.Content>
					</Card>
					</>
			:
			<Grid columns={2} style={{ marginBottom: 0 }}>
				<Grid.Column computer={4} mobile={8} tablet={6}>
					<Card
						style={{
							...styles.card,
							backgroundColor: cardBackgroundColor ?? 'white',
						}}
					>
						<Card.Header style={{ margin: 5 }}>Scan à réaliser</Card.Header>
						<Card.Content>{cardContent}</Card.Content>
					</Card>
				</Grid.Column>
				<Grid.Column computer={12} mobile={8} tablet={10}>
					<Card style={styles.card}>
						<Card.Content>
								<div style={styles.borderedCard}>
									<Grid columns={1}>
										<Grid.Row>
											<Grid.Column style={styles.centered}>
												Scanner votre code...
											</Grid.Column>
										</Grid.Row>
										<Grid.Row>
											<Grid.Column
												style={{ ...styles.subtitle, ...styles.centered }}
											>
												Puis faites "Entrée" ou cliquer sur le bouton valider
											</Grid.Column>
										</Grid.Row>
										<Grid.Row>
											<Grid.Column style={styles.centered}>
												<input
													style={styles.scanInput}
													ref={inputRef}
													autoFocus
													autoComplete='off'
													type='text'
													name='scanned-value'
													onChange={(e) => {
														setScanInputValue(e.target.value);
													}}
													value={scanInputValue}
													onKeyDown={handleKeyDown}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</div>
						</Card.Content>
						<Card.Content extra>
							<div className='ui two buttons'>	
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										close(true);
									}}
								>
									<Icon name='remove' /> Annuler
								</Button>
								<Button
									primary
									onClick={() => submitAlternativeScanner(scanInputValue)}
									disabled={!regex.test(scanInputValue)}
								>
									<Icon name='checkmark' /> Valider
								</Button>
							</div>
						</Card.Content>
					</Card>
				</Grid.Column>
			</Grid>
			}
			<Modal open={barcodeErrorOpen}>
				<Modal.Header>Erreur</Modal.Header>
				<Modal.Content>
					Le code-barres que vous venez de scanner ne correspond pas au format attendu
				</Modal.Content>
				<Modal.Actions>
					<Button
						color='blue'
						content='Ok'
						onClick={() => setBarcodeErrorOpen(false)}
					/>
				</Modal.Actions>
			</Modal>
		</div>
	);
};

const styles = {
	card: {
		width: '100%',
	},
	borderedCard: {
		border: '1px solid grey',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: 32,
		padding: 8,
	},
	scanInput: {
		borderRadius: 5,
		fontSize: 20,
		outline: 0,
	},
	subtitle: {
		display: 'block',
		fontSize: 20,
	},
	centered: {
		display: 'flex',
		justifyContent: 'center',
	},

};

export default ScanContainer;
